import template from './auth-warning.html'
import './auth-warning.scss'

const authWarning = {
  bindings: { link: '<' },
  template
}

export default authWarning
